import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Col, Container, Row} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'

import s from './Make1099How.module.scss'
const cx = cn.bind(s)

interface IMake1099HowProps {
	className?: string
	content: IMake1099Content['how']
}

/** Make1099How block component */
const Make1099How: FC<IMake1099HowProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<LandingsTitle
							className={s.title}
							title={content?.title}
							subtitle={content?.subtitle}
						/>
					</Col>
				</Row>
				<div className={cx('description', 'ta-center')}>
					<p className={cx('description__title', 'h3')}>
						{content?.payer_and_recipents_info?.title}
					</p>
					<p>{content?.payer_and_recipents_info?.subtitle}</p>
				</div>
				<Row>
					<Col lg={{span: 10, offset: 1}} xl={{span: 8, offset: 2}}>
						<div className={s.blocks}>
							{content?.payer_and_recipents_info?.items?.leftList && (
								<PortableBlocks blockContent={content?.payer_and_recipents_info?.items?.leftList} />
							)}
							{content?.payer_and_recipents_info?.items?.rightList && (
								<PortableBlocks
									blockContent={content?.payer_and_recipents_info?.items?.rightList}
								/>
							)}
						</div>
					</Col>
				</Row>

				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<ul className={cx('boxes')}>
							{content?.payer_and_recipents_info?.boxes?.map((box, index) => (
								<li className={cx('boxes__item')} key={box._key}>
									<h4 className={cx('boxes__title', 'h3')}>
										Box #{index + 1}. {box.title}
									</h4>
									<p className={cx('boxes__text')}>{box.description}</p>
								</li>
							))}
						</ul>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

Make1099How.displayName = 'Make1099How'

export default Make1099How
